import { Suspense, useEffect, useState } from "react";
import { Drawer, Layout } from "antd";
import { Outlet } from "react-router-dom";
import SideBar from "./SideBar";
import AppHeader from "./AppHeader/AppHeader";
import { useAuthLayoutContainer } from "./useAuthLayoutContainer";
import LogoLoader from "@Components/LogoLoader/LogoLoader";
import { APP_NAME } from "@Constants/app";
const { Header, Content, Footer } = Layout;

const AppLayout = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const { route, selectedKey, moduleTitle, navigate } =
    useAuthLayoutContainer();

  const sideBarParams = { route, selectedKey, navigate };
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (moduleTitle) {
      document.title = `${moduleTitle} - ${APP_NAME}`;
    } else {
      document.title = APP_NAME;
    }
  }, [moduleTitle]);

  const toggleSidebar = () => {
    setIsSidebarVisible((prev) => !prev);
  };

  return (
    <div className="min-h-screen bg-primaryGreen">
      {/* App Header - Full width at top */}
      <Header
        className="app-header-fixed bg-white flex items-center justify-between border-b !border-strokeBorder"
        style={{
          padding: "0px 20px",
          background: "#ffffff",
          borderBottom: "1px solid #DEE2E0",
          height: "var(--top-bar-height)",
        }}
      >
        {/* Left side - Logo and Admin Dashboard text */}
        <div className="flex items-center gap-4">
          {isMobileView && (
            <div
              onClick={(e) => {
                if (e && e.stopPropagation) e.stopPropagation();
                setIsSidebarVisible(true);
              }}
              className="hamburger-btn cursor-pointer flex items-center justify-center text-lg"
              style={{
                width: "40px",
                height: "42px",
                background: "#fff",
                borderRadius: "50%",
                color: "#8B6A45",
                fontWeight: "600",
                zIndex: 99,
              }}
            >
              ☰
            </div>
          )}
          {/* <div
            className="cursor-pointer flex-shrink-0 pl-2"
            onClick={() =>
              navigate(NavigationRoutes.DASHBOARD_ROUTES.DASHBOARD)
            }
          >
            <img src={Logo} width={120} height={40} alt="story tree Logo" />
          </div> */}
        </div>

        <AppHeader moduleTitle={moduleTitle} />
      </Header>

      {/* Main Layout - Sidebar and Content */}
      <div className="flex h-full ">
        {isMobileView ? (
          <Drawer
            placement="left"
            closable={true}
            maskClosable={true}
            mask={false}
            onClose={toggleSidebar}
            zIndex={1000}
            open={isSidebarVisible}
            className="w-[var(--side-bar-width)]"
            styles={{
              body: {
                padding: 0,
                background: "#1F3D2B",
              },
            }}
          >
            <SideBar {...sideBarParams} />
          </Drawer>
        ) : (
          <aside
            className="hidden lg:block fixed left-0 top-0 h-screen z-0"
            style={{ width: "var(--side-bar-width)" }}
          >
            <SideBar {...sideBarParams} />
          </aside>
        )}

        {/* Main Content Area */}
        <div
          className="flex-1 bg-primaryGreen lg:ml-[var(--side-bar-width)] min-w-0"
          style={{
            marginTop: "var(--top-bar-height)",
            minHeight: "calc(100vh - var(--top-bar-height))",
          }}
        >
          <Content
            style={{
              padding: "20px",
            }}
            className="h-full overflow-y-auto overflow-x-hidden custom-scrollbar min-w-0"
          >
            <div className="pb-20 relative">
              <Suspense fallback={<LogoLoader mode="fullscreen" />}>
                <Outlet />
              </Suspense>
            </div>
          </Content>
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
